import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-m-4" }
const _hoisted_2 = { class: "p-fluid p-field p-col-4" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "address",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-m-2 p-col-6" }
const _hoisted_6 = { class: "p-d-flex p-flex-row" }
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_InputText, {
          id: "address",
          class: "kn-material-input",
          modelValue: _ctx.model.address,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model.address = $event))
        }, null, 8, ["modelValue"]),
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('documentExecution.documentDetails.designerDialog.xmlaAddress')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('documentExecution.documentDetails.designerDialog.xmlaParameters')), 1),
        _createVNode(_component_Button, {
          id: "add-parameter-button",
          class: "kn-button kn-button--primary p-ml-auto",
          label: _ctx.$t('documentExecution.documentDetails.designerDialog.addParameter'),
          onClick: _ctx.addParameter
        }, null, 8, ["label", "onClick"])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.xmlModel?.parameters,
        class: "p-datatable-sm kn-table p-m-5",
        responsiveLayout: "stack",
        breakpoint: "960px"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.descriptor.xmlaParametersColumns, (column) => {
            return (_openBlock(), _createBlock(_component_Column, {
              class: "kn-truncated p-mr-2",
              key: column.header,
              field: column.field,
              header: _ctx.$t(column.header)
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_InputText, {
                    class: "kn-material-input p-inputtext-sm p-mr-2",
                    modelValue: slotProps.data[slotProps.column.props.field],
                    "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _hoisted_9
                ])
              ]),
              _: 2
            }, 1032, ["field", "header"]))
          }), 128)),
          _createVNode(_component_Column, {
            style: _ctx.descriptor.iconColumnStyle
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                class: "p-button-link",
                onClick: ($event: any) => (_ctx.deleteParameter(slotProps.index)),
                "data-test": 'delete-button-' + slotProps.index
              }, null, 8, ["onClick", "data-test"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}